import { useGetBlogListQuery } from "@redux/blog/blogApi/blogApi";
import { LayoutMain } from "@unisearch/theme/layout";
import { authAtom } from "@_recoil/_state";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import AdvertisementRow from "@unisearch/common/advertisement/row";

const BlogFeatured = dynamic(
  () => import("@modules/study/blog/blog_home/blog_featured"),
  {
    ssr: false,
  }
);
const BlogRegistration = dynamic(
  () => import("@modules/study/blog/blog_home/blog_registration"),
  {
    ssr: false,
  }
);
const BlogTrending = dynamic(
  () => import("@modules/study/blog/blog_home/blog_trending"),
  {
    ssr: false,
  }
);
const BlogList = dynamic(
  () => import("@modules/study/blog/blog_home/blog_list"),
  {
    ssr: false,
  }
);

const Blog = () => {
  const router = useRouter();
  const { query } = router;
  const [profileInfo, setProfileInfo] = useState();
  const [paginate, setPaginate] = useState();
  const [page, setPage] = useState(null);
  const [blogList, setBlogList] = useState([]);
  const profileInfos = useRecoilValue(authAtom);
  const { data, isLoading: loading, error } = useGetBlogListQuery({
    page: page,
    limit: 6,
  });

  useEffect(() => {
    if (query) {
      setPage(parseInt(query.page) || 1);
    }
  }, [query]);
  useEffect(() => {
    setBlogList(data?.data?.results);
    setPaginate({
      total: data?.data?.total,
      limit: data?.data?.limit,
      page_total: data?.data?.page_total,
      currentPage: data?.data?.currentPage,
    });
  }, [data]);

  useEffect(() => {
    setProfileInfo(profileInfos);
  }, [profileInfos]);

  const handleChange = (pageNum) => {
    router.push(`/blog/?page=${pageNum}`, undefined, { shallow: true });
    setPage(pageNum);
  };

  return (
    <LayoutMain
      isHeaderSticky={true}
      title={`Blog`}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/blog`}
    >
      <BlogFeatured />

      {/* ad */}
      <div className="bg-[#f1f5fd] lg:mt-[-30px] pb-8">
        <AdvertisementRow
          srcDesktop="/ad/study-in-au.webp"
          srcMobile="/ad/study-in-au-mobile.webp"
          url="https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
        />
      </div>

      <BlogTrending />
      {!profileInfo && <BlogRegistration />}
      <BlogList
        loadingList={loading}
        error={error}
        blogList={blogList}
        handlePager={handleChange}
        paginate={paginate}
      />
    </LayoutMain>
  );
};

export default Blog;
